export const coproTypes = {
  1: 'Copropriété',
  2: 'ASL',
  3: 'Immeuble tertiaire',
  4: 'AFUL',
  5: 'Autre',
};

export const COPRO_TYPE_FILTER_COMPANY_COPRO = 'Mes copropriétés';
export const COPRO_TYPE_FILTER_SUBCONTRACTED_COPRO = 'Mes copropriétés sous-traitées';
export const COPRO_TYPE_FILTER_SUBCONTRACTOR_FOR_COPRO = 'Copropriétés dont je suis le sous-traitant';
